import { FC } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Card, Container } from "@mui/material";
import { Form, Formik, FormikValues } from "formik";

import Button from "../../../common/Button";
import LoginInputField from "../common/LoginInputField";
import LoginLogoSection from "../common/LoginLogoSection";

import * as tokenService from "../../../../services/token";
import userService from "../../../../services/user";

import { useAppDispatch } from "../../../../redux/store";
import { setLoadingAction } from "../../../../redux/utils/actions";
import RoutingList from "../../../../utils/RoutingList";

import styles from "../login.module.scss";
import {
  verifyAndChangePasswordInitialData,
  verifyChangePassValidationSchema,
} from "../utils";

const ChangePasswordAfterVerify: FC = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const saveHandler = async (values: FormikValues) => {
    try {
      dispatch(setLoadingAction(true));
      const token = tokenService.getAccessToken();
      const res = await userService.verify({
        token,
        newPass: values.newPass,
      });
      tokenService.clear();
      toast.success(res.data.msg);
      dispatch(setLoadingAction(false));
      if (res.data.data.isVerified) {
        navigate(RoutingList.login.index);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.msg);
      dispatch(setLoadingAction(false));
    }
  };

  return (
    <Container>
      <Formik
        enableReinitialize={true}
        initialValues={verifyAndChangePasswordInitialData}
        validationSchema={verifyChangePassValidationSchema}
        onSubmit={(values, { setSubmitting, validateForm, setErrors }) => {
          saveHandler(values);
        }}
      >
        {({ values, setFieldValue, resetForm, handleChange, handleSubmit }) => (
          <Form className={`${styles.loginWrap} ${styles.formSpaceTop}`}>
            <>
              <LoginLogoSection />
              <Card className={styles.loginCard} variant="outlined">
                <div className={styles.cardBody}>
                  <div className={`text-center ${styles.headerTop}`}>
                    <h2 className="font-weight-semi-bold mb-1">
                      Change your password ?
                    </h2>
                    <p className="font-size-18">
                      Please enter your new password
                    </p>
                  </div>
                  <LoginInputField
                    title="New Password"
                    name="newPass"
                    placeholder="New Password"
                    type="password"
                  />
                  <LoginInputField
                    title="Confirm New Password"
                    name="confirmNewPass"
                    placeholder="Confirm New Password"
                    type="password"
                  />

                  <div
                    className={`d-flex justify-content-center ${styles.loginFooter}`}
                  >
                    <Button color="alert" type="submit" className="mr-12">
                      Continue
                    </Button>
                  </div>
                </div>
              </Card>
            </>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default ChangePasswordAfterVerify;
